export interface GxPrimaryButtonProps {
  label: string;
  handleSubmit?: () => void;
  disabled?: boolean;
  isLoading?: boolean;
  type?: "button" | "submit";
}

const GxPrimaryButton: React.FC<GxPrimaryButtonProps> = ({
  label,
  handleSubmit = () => {},
  disabled = false,
  isLoading = false,
  type = "button",
}) => {
  return (
    <button
      type={type}
      onClick={handleSubmit}
      disabled={disabled || isLoading}
      className="py-3 px-15 rounded-[30px] gx-h4-eb uppercase transition-all
      bg-(--primaryColor) text-white
      hover:opacity-90
      disabled:bg-gray-300 disabled:text-gray-500
      disabled:cursor-not-allowed! disabled:border disabled:border-gray-400
      cursor-pointer"
    >
      {isLoading ? "Loading..." : label}
    </button>
  );
};

export default GxPrimaryButton;
